export default "__VITE_ASSET__9TjkMmlV__"